<template>
  <v-dialog v-model="dialog" max-width="500px" :persistent="loading" @click:outside="close">
    <v-card  v-if="!!payment && !!rental">
      <v-card-text class="d-flex flex-column align-center">
        <v-icon color="error" size="70">mdi-alert-circle</v-icon>
        <h2 class="text-center">Tem certeza que deseja <br />cancelar essa cobrança?</h2>
      </v-card-text>
      <v-card-actions class="mt-4">
        <v-btn color="primary" outlined @click="close" :disabled="loading">Fechar</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="error" @click="destroy" depressed  :loading="loading">Cancelar Cobrança</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import RENTAL from '@/services/rental'

export default {
  data() {
    return {
      dialog: false,
      loading: false,
      payment: null,
      rental: null,
    }
  },
  methods: {
    async destroy() {
      try {
        this.loading = true
        await RENTAL.payment.cancel(this.rental.id, this.payment.id)
        this.$emit('success')
        this.loading = false
        this.close()
      } catch (error) {
        this.loading = false
        this.$toast.fire({
          icon: 'error',
          title: error.message || 'Erro ao excluir usuário',
        })
      }
    },
    close() {
      if (this.loading) return
      this.dialog = false
      this.loading = false
      this.payment = null
      this.rental = null
    },
    open({ payment, rental }) {
      this.dialog = true
      this.payment = payment
      this.rental = rental
    },
  },
  mounted() {
    this.$parent.$on('payment-delete', this.open)
  },
}
</script>

<style></style>
